import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { Toaster } from "@/components/ui/sonner";
import Navbar from "./components/layout/Navbar";
import Footer from "./components/layout/Footer";
import Home from "./pages/Home";
import Services from "./pages/Services";
import AircoPage from "./pages/services/Airco";
import WarmtepompPage from "./pages/services/Warmtepomp";
import ZonnepanelenElektraPage from "./pages/services/ZonnepanelenElektra";
import CVSanitairPage from "./pages/services/CVSanitair";
import Projects from "./pages/Projects";
import Quote from "./pages/Quote";
import Blog from "./pages/Blog";

// Scroll to top on route change
const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

const App = () => {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <div className="flex flex-col min-h-screen font-sans bg-gray-50 text-gray-900">
        <Navbar />
        <main className="flex-grow">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/diensten" element={<Services />} />
            <Route path="/diensten/airco" element={<AircoPage />} />
            <Route path="/diensten/warmtepomp" element={<WarmtepompPage />} />
            <Route path="/diensten/zonnepanelen-elektra" element={<ZonnepanelenElektraPage />} />
            <Route path="/diensten/cv-sanitair" element={<CVSanitairPage />} />
            <Route path="/projecten" element={<Projects />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/offerte" element={<Quote />} />
          </Routes>
        </main>
        <Footer />
        <Toaster />
      </div>
    </BrowserRouter>
  );
};

export default App;
